// extracted by mini-css-extract-plugin
module.exports = {"votingCard":"TaskVoting_votingCard__siMSU","votingCardTitle":"TaskVoting_votingCardTitle__Fqank","upvoteCard":"TaskVoting_upvoteCard__Ll0B1","upvoted":"TaskVoting_upvoted__ddEqj"};